import React from 'react';

const WebsiteMenuPage = React.lazy(() => import('pages/WebsiteMenu/WebsiteMenuPage'));
const WebsiteMenuAddPage = React.lazy(() => import('pages/WebsiteMenu/WebsiteMenuAddPage'));

const WebsiteMenuRoute = [
  {
    path: '/website-menu',
    exact: true,
    name: 'Danh sách website menu',
    function: 'CMS_WEBSITECATEGORY_VIEW',
    component: WebsiteMenuPage,
  },
  {
    path: '/website-menu/add',
    exact: true,
    name: 'Thêm mới website menu',
    function: 'CMS_WEBSITECATEGORY_ADD',
    component: WebsiteMenuAddPage,
  },
  {
    path: '/website-menu/edit/:website_category_id',
    exact: true,
    name: 'Chỉnh sửa website menu',
    function: 'CMS_WEBSITECATEGORY_EDIT',
    component: WebsiteMenuAddPage,
  },
  {
    path: '/website-menu/detail/:website_category_id',
    exact: true,
    name: 'Chi tiết website menu',
    function: 'CMS_WEBSITECATEGORY_VIEW',
    component: WebsiteMenuAddPage,
  },
];

export default WebsiteMenuRoute;
